import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { SliderVideo } from '@components/slider-video/models';
import { ButtonComponent } from '@shared/components/button';
import { TitleComponent } from '@shared/components/title';
import { VideoComponent } from '@shared/components/video';

@Component({
  selector: '+app-slider-video',
  imports: [TitleComponent, VideoComponent, ButtonComponent],
  templateUrl: './slider-video.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SliderVideoComponent extends AbstractDynamicComponent<SliderVideo> implements OnInit {
  videoGroupName = signal<null | string>(null);

  ngOnInit(): void {
    this.videoGroupName.set(`slider-video-${this.position}`);
  }
}
